import { Toaster as SonnerToaster } from 'sonner';
import type React from 'react';

/** SPEC §11 — toasts for all mutations; no browser confirm(). */
export function Toaster(): React.JSX.Element {
  return (
    <SonnerToaster
      position="bottom-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: 'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
        },
      }}
    />
  );
}

export { toast } from 'sonner';
